import { useState, useEffect } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useAuth } from '@/contexts/AuthContext';

const pageTitles: Record<string, string> = {
  '/admin/dashboard': 'Dashboard',
  '/admin/basvurular': 'Başvurular',
  '/admin/ogrenciler': 'Öğrenciler',
  '/admin/ogretmenler': 'Öğretmenler',
  '/admin/yonlendirme': 'Öğrenci Yönlendirme',
  '/admin/deneme-dersleri': 'Deneme Dersleri',
  '/admin/aktif-dersler': 'Aktif Dersler',
  '/admin/odemeler': 'Ödeme & Dekontlar',
  '/admin/hak-edisler': 'Öğretmen Hak Edişleri',
  '/admin/grup-dersleri': 'Grup Dersleri',
  '/admin/raporlar': 'Raporlar',
  '/admin/ayarlar': 'Ayarlar',
};

export default function AdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { user, role, loading } = useAuth();

  const title = pageTitles[location.pathname] ?? 'Yönetim Paneli';

  useEffect(() => {
    if (!loading && (!user || role !== 'yonetici')) {
      navigate('/', { replace: true });
    }
  }, [user, role, loading, navigate]);

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-[#f0f4ff]">
        <div className="flex flex-col items-center gap-3">
          <i className="ri-loader-4-line text-4xl text-[#1a2f5a]/40 animate-spin" />
          <p className="text-slate-400 text-sm">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  if (!user || role !== 'yonetici') return null;

  return (
    <div className="flex h-screen bg-[#f0f4ff] overflow-hidden">
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
      <div className="flex-1 flex flex-col overflow-hidden min-w-0">
        <Header onMenuToggle={() => setSidebarOpen(true)} title={title} />
        <main className="flex-1 overflow-y-auto p-4 md:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}